import { createContext } from 'use-context-selector';
import produce from 'immer';
import { useReducer } from 'react';
export var ComposerContext = createContext(undefined);
export var ComposerContextAction = createContext(undefined);
export var composerReducer = function (composerState, action) {
    switch (action.type) {
        case 'changeComposerType':
            return produce(composerState, function (draft) {
                draft.composerType = action.composerType;
            });
        default:
            throw new Error("Unknown action type: " + action.type);
    }
};
// @ts-ignore
export var useInitComposerValue = function (composerGlobalContext) { return useReducer(composerReducer, composerGlobalContext); };
